import { Support } from '@zappyrent/hundop';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useStore from '../../store';
import {
  StyledHelpCard,
  StyledHelpCardBottom,
  StyledHelpCardContent,
  StyledHelpCardDivider,
  StyledHelpCardImage,
  StyledHelpCardTitle,
  StyledHelpCardTop,
  StyledNavMenu,
  StyledNavMenuList,
  StyledNavMenuListItem,
  StyledNavMenuListItemButton,
  StyledNavMenuListItemLink,
  SupportLink,
} from './NavMenu.styles';

const NavMenu = (): JSX.Element => {
  const user = useStore(state => state.user);
  const userType = user?.type;

  const { locale } = useParams();
  const { t } = useTranslation(['navigation', 'common', 'translation']);
  const navigate = useNavigate();
  const currentPage = useLocation().pathname.split('/').pop();

  const handleNavMenuListItemButtonClick = (pageToNavigateTo: string) => {
    navigate(`/${locale}/${pageToNavigateTo}`);
  };

  return (
    <>
      <StyledNavMenu>
        <StyledNavMenuList>
          <StyledNavMenuListItem
            user={userType}
            isActive={currentPage === t('navigation:profile')}
          >
            <StyledNavMenuListItemButton
              onClick={handleNavMenuListItemButtonClick.bind(
                null,
                t('navigation:profile'),
              )}
            >
              {upperFirst(t('navigation:profile'))}
            </StyledNavMenuListItemButton>
          </StyledNavMenuListItem>
          {userType === 'landlord' && (
            <>
              <StyledNavMenuListItem
                user={userType}
                isActive={currentPage === t('navigation:personal-information')}
              >
                <StyledNavMenuListItemButton
                  onClick={handleNavMenuListItemButtonClick.bind(
                    null,
                    t('navigation:personal-information'),
                  )}
                >
                  {upperFirst(t('translation:personalInformation'))}
                </StyledNavMenuListItemButton>
              </StyledNavMenuListItem>
              <StyledNavMenuListItem
                user={userType}
                isActive={currentPage === t('navigation:listings')}
              >
                <StyledNavMenuListItemButton
                  onClick={handleNavMenuListItemButtonClick.bind(
                    null,
                    t('navigation:listings'),
                  )}
                >
                  {upperFirst(t('navigation:listings'))}
                </StyledNavMenuListItemButton>
              </StyledNavMenuListItem>
              <StyledNavMenuListItem
                user={userType}
                isActive={currentPage === t('navigation:bookings')}
              >
                <StyledNavMenuListItemButton
                  onClick={handleNavMenuListItemButtonClick.bind(
                    null,
                    t('navigation:bookings'),
                  )}
                >
                  {upperFirst(t('navigation:bookings'))}
                </StyledNavMenuListItemButton>
              </StyledNavMenuListItem>
            </>
          )}
          {userType === 'tenant' && (
            <>
              {/* <StyledNavMenuListItem
                user={userType}
                isActive={currentPage === t('navigation:visits')}
              >
                <StyledNavMenuListItemLink
                  href={`${process.env.REACT_APP_SITE_URL}/${locale}/user/dashboard/myVisits`}
                  target="_blank"
                  rel="noreferrer"
                  title={upperFirst(t('navigation:visits'))}
                >
                  {upperFirst(t('navigation:visits'))}
                </StyledNavMenuListItemLink>
              </StyledNavMenuListItem> */}

              <StyledNavMenuListItem
                user={userType}
                isActive={currentPage === t('navigation:sentOffers')}
              >
                <StyledNavMenuListItemButton
                  onClick={handleNavMenuListItemButtonClick.bind(
                    null,
                    t('navigation:bookings'),
                  )}
                >
                  {upperFirst(t('navigation:sentOffers'))}
                </StyledNavMenuListItemButton>
              </StyledNavMenuListItem>
            </>
          )}
          <StyledNavMenuListItem
            user={userType}
            isActive={currentPage === t('navigation:documents')}
          >
            <StyledNavMenuListItemButton
              onClick={handleNavMenuListItemButtonClick.bind(
                null,
                t('navigation:documents'),
              )}
            >
              {upperFirst(t('navigation:documents'))}
            </StyledNavMenuListItemButton>
          </StyledNavMenuListItem>
          <StyledNavMenuListItem user={userType}>
            <StyledNavMenuListItemLink
              href={`${process.env.REACT_APP_SITE_URL}/${locale}/logout`}
              title={upperFirst(t('navigation:logout'))}
            >
              {upperFirst(t('navigation:logout'))}
            </StyledNavMenuListItemLink>
          </StyledNavMenuListItem>
        </StyledNavMenuList>
      </StyledNavMenu>
      {userType === 'landlord' && (
        <StyledHelpCard>
          <StyledHelpCardTop>
            <StyledHelpCardImage>
              <Support />
            </StyledHelpCardImage>
            <StyledHelpCardContent>
              <StyledHelpCardTitle>
                {t('navigation:needHelp')}
              </StyledHelpCardTitle>
              <SupportLink
                href={`tel:+390294755452`}
                title={t('navigation:callUs')}
              >
                +39 02 9475 5452
              </SupportLink>
            </StyledHelpCardContent>
          </StyledHelpCardTop>
          <StyledHelpCardDivider />
          <StyledHelpCardBottom>
            <span>{t('common:thisIsTheNumberDedicatedToYou')}</span>
            <span>
              <strong>Lun - Ven</strong>
              <br /> 9:30 - 12:30, 14:30 - 17:30
            </span>
          </StyledHelpCardBottom>
        </StyledHelpCard>
      )}
    </>
  );
};

export default NavMenu;
